import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import messages from 'store/app/entities/messages/action';
import * as chatPanel from 'store/app/ui/ChatPanelSlice';
import employeeList from 'store/app/ui/drawers/employeeList/action';
import authTokenSelector from 'store/selectors/authToken';
import currentChannel from 'store/selectors/currentChannel';
import isSuperAdmin from 'store/selectors/isSuperAdmin';

const mapStateToProps = (state, ownProps) => {
  return {
    currentChannel: currentChannel(state),
    messageId: ownProps.message._id,
    canDelete: ownProps.message.canDelete,
    canEdit: ownProps.message.canEdit,
    canPin: ownProps.message.canPin,
    canForward: ownProps.message.canForward,
    permissionsState: ownProps.message.permissionsState || null,
    temp: ownProps.message.temp,
    authToken: authTokenSelector(state),
    isSuperAdmin: isSuperAdmin(state),
  };
};

const mapDispatchToProps = dispatch => ({
  actions: {
    messages: bindActionCreators(messages, dispatch),
    chatPanel: bindActionCreators(chatPanel, dispatch),
    drawers: {
      employeeList: bindActionCreators(employeeList, dispatch),
    },
  },
});

export default connect(mapStateToProps, mapDispatchToProps);
